import React from 'react';
import { Box, SxProps, Typography } from '@mui/material';
import Select, { components } from 'react-select';
import { selectBox, selectStyles } from 'app/components/CustomSelect/CustomSelect.sx';
import { SelectProps } from 'app/constants/types';
import logger from 'app/utils/logger';
import { red2 } from 'app/components/ThemeProvider/colors';
import { Controller } from 'react-hook-form';

interface Props {
  title?: string;
  placeholder?: string;
  options: SelectProps[];
  width?: string;
  value?: SelectProps | null;
  onChange?: (newValue: any) => void;
  optionLabel?: boolean;
  labelOption?: string;
  optionValue?: boolean;
  valueOption?: string;
  rest?: any;
  isValid?: boolean;
  control?: any;
  disabled?: boolean;
  lang?: boolean;
  isSearchable?: boolean;
  errorText?: string;
}

const NoOptionsMessage = (props: any) => {
  return (
    <components.NoOptionsMessage {...props}>
      <span className="custom-css-class">Digər hesabınız yoxdur</span>
    </components.NoOptionsMessage>
  );
};

const CustomSelect = (props: Props) => {
  const {
    title,
    placeholder,
    options,
    width,
    value,
    onChange,
    optionValue,
    valueOption,
    labelOption,
    optionLabel,
    rest,
    isValid,
    control,
    disabled,
    lang,
    isSearchable,
    errorText,
  } = props;

  return (
    <Box sx={width !== undefined ? { ...selectBox(lang), width } : selectBox(lang)}>
      <Typography sx={{ fontSize: '15px', fontWeight: 400, lineHeight: 1 }}>{title}</Typography>
      {control !== undefined && (
        <Controller
          name={rest.name}
          control={control}
          render={({ field: { onChange: onChangeInput, ref } }) => (
            <Select
              ref={ref}
              styles={
                isValid
                  ? { ...selectStyles, control: (base) => ({ ...base, ...selectStyles.control(), borderColor: red2 }) }
                  : selectStyles
              }
              isSearchable={isSearchable !== undefined && isSearchable === true}
              options={options}
              placeholder={placeholder}
              components={{
                IndicatorSeparator: () => null,
                NoOptionsMessage,
              }}
              value={value}
              onChange={(selectedOption) => {
                onChangeInput(selectedOption);
                onChange(selectedOption);
              }}
              menuPortalTarget={document.body}
              getOptionLabel={optionLabel && ((option: any) => option[labelOption])}
              getOptionValue={optionValue && ((option: any) => option[valueOption])}
              isDisabled={disabled}
            />
          )}
        />
      )}
      {isValid && <Typography sx={{ color: 'red', fontSize: '14px' }}>{errorText}</Typography>}
    </Box>
  );
};

export default CustomSelect;
